/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchHistory } from './SearchHistory';
import {
    SearchHistoryFromJSON,
    SearchHistoryFromJSONTyped,
    SearchHistoryToJSON,
    SearchHistoryToJSONTyped,
} from './SearchHistory';

/**
 * 
 * @export
 * @interface PaginatedSearchHistoryList
 */
export interface PaginatedSearchHistoryList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedSearchHistoryList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSearchHistoryList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSearchHistoryList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<SearchHistory>}
     * @memberof PaginatedSearchHistoryList
     */
    results: Array<SearchHistory>;
}

/**
 * Check if a given object implements the PaginatedSearchHistoryList interface.
 */
export function instanceOfPaginatedSearchHistoryList(value: object): value is PaginatedSearchHistoryList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedSearchHistoryListFromJSON(json: any): PaginatedSearchHistoryList {
    return PaginatedSearchHistoryListFromJSONTyped(json, false);
}

export function PaginatedSearchHistoryListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedSearchHistoryList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(SearchHistoryFromJSON)),
    };
}

  export function PaginatedSearchHistoryListToJSON(json: any): PaginatedSearchHistoryList {
      return PaginatedSearchHistoryListToJSONTyped(json, false);
  }

  export function PaginatedSearchHistoryListToJSONTyped(value?: PaginatedSearchHistoryList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(SearchHistoryToJSON)),
    };
}

